<div class="report-dialog-container p-3">
    <!-- Title -->
    <div class="d-flex justify-content-between align-items-center mb-3 border-bottom pb-2">
        <h3 class="font-weight-bold m-0 fs-18">
            {{ 'menu_export_report.dialog_create.title' | translate }}
        </h3>
        <button mat-icon-button (click)="onCancel()" class="btn-close-dialog" type="button">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <mat-dialog-content class="m-0 p-0">
        <form [formGroup]="infoForm" class="dialog-form-container mt-2" *ngIf="infoForm">

            <!-- Hàng 1: Mã định danh | Tên báo cáo | Kỳ báo cáo -->
            <div class="row">
                <div class="col-md-4">
                    <mat-form-field appearance="standard" class="w-100">
                        <mat-label>{{ 'menu_export_report.dialog_create.tax_code' | translate }}</mat-label>
                        <input matInput formControlName="certificateNo" readonly />
                    </mat-form-field>
                </div>

                <div class="col-md-4">
                    <mat-form-field appearance="standard" class="w-100">
                        <mat-label>
                            {{ 'menu_export_report.dialog_create.report_name' | translate }} <span
                                class="text-danger">*</span>
                        </mat-label>
                        <input matInput formControlName="reportName" (blur)="focusOut('reportName')"
                            [placeholder]="'menu_export_report.dialog_create.placeholder.report_name' | translate"
                            maxlength="255" />
                        <mat-error *ngIf="infoForm.get('reportName')?.hasError('required')">
                            {{ 'menu_export_report.dialog_create.validation.report_name_required' | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-md-4">
                    <mat-form-field appearance="standard" class="w-100">
                        <mat-label>
                            {{ 'menu_export_report.dialog_create.report_period' | translate }} <span
                                class="text-danger">*</span>
                        </mat-label>
                        <input matInput [value]="selectedReportPeriodLabel" readonly disabled />
                    </mat-form-field>
                </div>
            </div>

            <!-- Hàng 2: Năm báo cáo | Dữ liệu từ ngày | Dữ liệu đến ngày -->
            <div class="row">
                <div class="col-md-4">
                    <mat-form-field appearance="standard" class="w-100">
                        <mat-label>
                            {{ 'menu_export_report.dialog_create.report_year' | translate }} <span
                                class="text-danger">*</span>
                        </mat-label>
                        <input matInput formControlName="reportYear" readonly />
                    </mat-form-field>
                </div>

                <!-- Dữ liệu từ ngày -->
                <div class="col-md-4">
                    <mat-form-field appearance="standard" class="w-100">
                        <mat-label>
                            {{ 'menu_export_report.dialog_create.from_date' | translate }} <span
                                class="text-danger">*</span>
                        </mat-label>
                        <!-- Bỏ [matDatepicker] để click vào input không mở popup -->
                        <input matInput formControlName="fromDate" readonly />
                        <!-- Thêm style="pointer-events: none;" để chặn click icon lịch -->
                        <mat-datepicker-toggle disabled matSuffix [for]="pickerFrom"
                            style="pointer-events: none; opacity: 0.5;">
                            <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"></i>
                        </mat-datepicker-toggle>
                        <mat-datepicker #pickerFrom></mat-datepicker>
                    </mat-form-field>
                </div>

                <!-- Dữ liệu đến ngày -->
                <div class="col-md-4">
                    <mat-form-field appearance="standard" class="w-100">
                        <mat-label>
                            {{ 'menu_export_report.dialog_create.to_date' | translate }} <span
                                class="text-danger">*</span>
                        </mat-label>
                        <!-- Bỏ [matDatepicker] để click vào input không mở popup -->
                        <input matInput formControlName="toDate" readonly />
                        <!-- Thêm style="pointer-events: none;" để chặn click icon lịch -->
                        <mat-datepicker-toggle disabled matSuffix [for]="pickerTo"
                            style="pointer-events: none; opacity: 0.5;">
                            <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"></i>
                        </mat-datepicker-toggle>
                        <mat-datepicker #pickerTo></mat-datepicker>
                    </mat-form-field>
                </div>
            </div>

            <!-- Hàng 3: Số hiệu báo cáo | Ngày báo cáo | Đối tượng -->
            <div class="row">
                <div class="col-md-4">
                    <mat-form-field appearance="standard" class="w-100">
                        <mat-label>{{ 'menu_export_report.dialog_create.report_number' | translate }}</mat-label>
                        <input matInput formControlName="reportNo" (blur)="focusOut('reportNo')"
                            [placeholder]="'menu_export_report.dialog_create.placeholder.report_number' | translate"
                            maxlength="50" />
                    </mat-form-field>
                </div>

                <div class="col-md-4">
                    <mat-form-field appearance="standard" class="w-100">
                      <mat-label>
                        {{ 'menu_export_report.dialog_create.report_date' | translate }}
                        <span class="text-danger">*</span>
                      </mat-label>
                  
                      <input 
                        matInput 
                        [matDatepicker]="pickerReportDate" 
                        name="reportDate"
                        [errorStateMatcher]="matcher"
                        (focus)="lastTouchedField = 'reportDate'"
                        (blur)="infoForm.controls['reportDate'].markAsTouched()"
                        (dateChange)="onDateInputChange('reportDate', pickerReportDateInput, infoForm.controls['reportDate'])"
                        (change)="onDateInputChange('reportDate', pickerReportDateInput, infoForm.controls['reportDate'])"
                        formControlName="reportDate"
                        [ngClass]="{ 'is-invalid': infoForm.controls['reportDate'].invalid }"
                        maxlength="10"
                        #pickerReportDateInput />
                  
                      <mat-datepicker-toggle matSuffix [for]="pickerReportDate">
                        <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                          [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                      </mat-datepicker-toggle>
                      
                      <mat-datepicker #pickerReportDate></mat-datepicker>
                  
                      <mat-error>
                        <span class="text-error">
                          {{ getErrorDateMessageV2(pickerReportDateInput.value, true, 'reportDate') }}
                        </span>
                      </mat-error>
                    </mat-form-field>
                  </div>

                <div class="col-md-4">
                    <mat-form-field appearance="standard" class="w-100">
                        <mat-label>
                            {{ 'menu_export_report.dialog_create.target_type' | translate }} <span
                                class="text-danger">*</span>
                        </mat-label>
                        <mat-select formControlName="targetType">
                            <mat-option *ngFor="let item of listTargetType" [value]="item.value">
                                {{ item.label | translate }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="infoForm.get('targetType')?.hasError('required')">
                            {{ 'menu_export_report.dialog_create.validation.target_type_required' | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

        </form>

        <p class="text-danger font-italic fs-13 mt-1">
            {{ "menu_export_report.note_declaration_bnv" | translate }}
        </p>

        <!-- Bảng danh sách các HĐVB đã chọn (Chỉ hiện thanh cuộn dọc khi danh sách dài, không phân trang) -->
        <div class="card-table-container p-3 mt-3">
            <!-- Header của bảng & Ô tìm kiếm -->
            <div class="d-flex justify-content-between align-items-center mb-3">
                <div class="font-weight-bold fs-15 text-dark">
                    {{ 'menu_export_report.selected_contracts_title' | translate }}
                    <span class="text-danger">({{ total }})</span>
                </div>

                <!-- Ô tìm kiếm -->
                <div class="search-input-wrapper">
                    <mat-icon class="search-icon">search</mat-icon>
                    <input #searchInput type="text" class="custom-search-input"
                        [placeholder]="'menu_export_report.search_contract_placeholder' | translate" maxlength="255"
                        (keyup)="applyFilter($event)" (blur)="onSearchBlur($event)" />

                    <mat-icon class="clear-icon" *ngIf="searchKey" (mousedown)="clearSearch(searchInput)">close
                    </mat-icon>
                </div>
            </div>
            <!-- Bảng dữ liệu -->
            <div class="table-scroll-container">
                <table mat-table [dataSource]="dataSource" class="w-100 custom-table">
                    <!-- STT -->
                    <ng-container matColumnDef="stt">
                        <th mat-header-cell *matHeaderCellDef class="text-center" style="width: 50px;">
                            {{ 'menu_export_report.stt' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element; let i = index" class="text-center font-weight-500">
                            {{ i + 1 }}
                        </td>
                    </ng-container>
                    <!-- UUID hợp đồng -->
                    <ng-container matColumnDef="uuid">
                        <th mat-header-cell *matHeaderCellDef style="min-width: 180px;">
                            {{ 'menu_export_report.contract_uuid' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element" style="min-width: 180px;" class="text-center">
                            {{ element.contractUUID }}
                        </td>
                    </ng-container>
                    <!-- Hợp đồng lao động -->
                    <ng-container matColumnDef="contractName">
                        <th mat-header-cell *matHeaderCellDef style="min-width: 220px; white-space: nowrap;">
                            {{ 'menu_export_report.labor_contract' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element" class="font-weight-500"
                            [matTooltip]="element.contractName + ' - ' + element.contractCode"
                            style="min-width: 220px; white-space: nowrap;">
                            {{ element.contractName }} - {{ element.contractCode }}
                        </td>
                    </ng-container>

                    <!-- Các bên ký hợp đồng -->
                    <ng-container matColumnDef="enterprises">
                        <th mat-header-cell *matHeaderCellDef style="min-width: 250px;">
                            {{ 'menu_export_report.sign_parties' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element" style="min-width: 250px;">
                            {{ element.contractEnterprises }}
                        </td>
                    </ng-container>
                    <!-- Ngày lập -->
                    <ng-container matColumnDef="creationTime">
                        <th mat-header-cell *matHeaderCellDef class="text-center" style="min-width: 100px;">
                            {{ 'menu_export_report.created_date' | translate }}
                        </th>
                        <td mat-cell *matCellDef="let element" class="text-center">
                            {{ element.creationTime | date: 'dd/MM/yyyy' }}
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>

                <div class="text-center p-3 text-muted" *ngIf="dataSource.filteredData.length === 0">
                    {{ 'menu_export_report.no_record' | translate }}
                </div>
            </div>
        </div>
    </mat-dialog-content>

    <!-- Buttons Footer -->
    <div class="d-flex justify-content-center align-items-center gap-3 mt-4 mb-2">
        <button type="button" class="btn-figma btn-cancel" (click)="onCancel()">
            <mat-icon class="btn-icon">cancel</mat-icon>
            <span>{{ 'button.cancel' | translate }}</span>
        </button>
        <button type="button" class="btn-figma btn-submit" (click)="onSubmit()">
            <mat-icon class="btn-icon">add</mat-icon>
            <span>{{ 'button.add' | translate }}</span>
        </button>
    </div>
</div>